export default Object.freeze({
  MOVING_AVERAGE_STEP: 10,
});
